import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const BoxStyles = ({ theme, isDisable }) => ({
  padding: '24px 16px',
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: 16,
  cursor: isDisable ? 'not-allowed' : 'pointer',
  background: isDisable ? theme.palette.background.grey.dark : theme.palette.background.grey.light,
  opacity: isDisable ? 0.7 : 'initial'
});

const IconWrapperStyle = ({ theme, disabled }) => ({
  width: '48px',
  height: '48px',
  borderRadius: '50%',
  backgroundColor: disabled
    ? theme.palette.background.grey.main
    : theme.palette.background.green.light
});

export const BoxStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isDisable'
})(BoxStyles);
export const IconWrapper = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'disabled'
})(IconWrapperStyle);
